import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { approveCustodyWallet } from '../cryptoWalletsEndpoints'
import type { CustodyWalletApprovalInput } from '../../types/cryptoWalletTypes'

/**
 * Approves a custody wallet that is pending validation — admin-service moves it
 * to `active`. Refused with a 409 when the wallet has already moved on.
 */
export function useApproveCustodyWalletMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (input: CustodyWalletApprovalInput) => approveCustodyWallet(input),
    // `onSettled`: a 409 means the cached status is stale, so re-read either way.
    // The status shows on the table, the open detail, and the VAISP queue and
    // its bucket counts.
    onSettled: (_result, _error, input) => {
      queryClient.invalidateQueries({
        queryKey: cryptoWalletsKeys.walletManagementDetail(input.investorId),
      })
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.walletManagementLists() })
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.vaspWalletLists() })
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.vaspWalletStatusCounts() })
    },
  })
}
